import { CustomRadio } from '../../../../lib/CustomRadio';
import { IsAllow, PlanTypes } from '../../../../redux-store/types/portfolio';
import {
    TextField,
    InputAdornment,
    FormControlLabel,
    Checkbox,
    Select,
    MenuItem,
} from '@material-ui/core';
import { Formik, FormikProps } from 'formik';
import en from '../../../../lang/en-us';
import { Values } from './SwitchInvestment';
import { isError, showHelperText } from './utils';
import { InvestThrough, MAX_LENGTHS } from './types';
import { UI_KEYS } from '../ExploreMFs/mf-helpers';
import { isAlphaNumeric } from '../../../../utils/constants';

type InvestMentComponentProps = {
    plan: PlanTypes;
    formikState: FormikProps<Values>;
    setEuin?: any;
};

const { dbCommercial } = en;

export const InvestMentMode = (props: InvestMentComponentProps): JSX.Element => {
    return (
        <div className="investment-mode ">
            <h3>
                <img src="/images/investment-mode.svg" alt="" />
                {dbCommercial.exploreMfs.mfInvestment.investmentMode}
            </h3>
            <div className="radio-div">
                <p>{dbCommercial.exploreMfs.mfInvestment.investingThrough}</p>
                <CustomRadio
                    name="investThrough"
                    list={
                        [PlanTypes.Direct, PlanTypes.D].includes(props.plan)
                            ? [
                                  {
                                      label: 'Direct',
                                      value: InvestThrough.direct,
                                  },
                                  {
                                      label: 'RIA',
                                      value: InvestThrough.ria,
                                  },
                              ]
                            : [
                                  {
                                      label: 'Distributor (ARN)',
                                      value: InvestThrough.arn,
                                  },
                              ]
                    }
                    selectedValue={
                        //if plan is regular then radio value is selected by default
                        [PlanTypes.Reggular, PlanTypes.R].includes(props.plan)
                            ? 0
                            : props.formikState.values.investThrough
                    }
                    handleRadioChange={(value: InvestThrough) => {
                        props.formikState.setFieldValue('investThrough', Number(value));
                        if (Number(value) === InvestThrough.direct) {
                            props.formikState.setFieldValue('riaCode', '');
                        }
                    }}
                />
            </div>
            {[PlanTypes.Reggular, PlanTypes.R].includes(props.plan) ? (
                <>
                    <div className="inputs-wrap">
                        <TextField
                            label={dbCommercial.exploreMfs.mfInvestment.enterArn}
                            id="enter-arn"
                            variant="outlined"
                            error={isError(props.formikState, 'arn1')}
                            helperText={showHelperText(props.formikState, 'arn1')}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if (
                                    event.target.value.length > MAX_LENGTHS.ARN_LENGTH ||
                                    !isAlphaNumeric(event.target.value)
                                )
                                    return;
                                props.formikState.setFieldValue('arn1', event.target.value);
                            }}
                            value={props.formikState.values.arn1}
                            name="arn1"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">ARN - </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label={dbCommercial.exploreMfs.mfInvestment.subBrokerCode}
                            id="sub-broker-code"
                            // error={isError(props.formikState, 'arn2')}
                            // helperText={showHelperText(props.formikState, 'arn2')}
                            variant="outlined"
                            placeholder="Optional"
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if (
                                    event.target.value.length > MAX_LENGTHS.SUB_BROKER_LENGTH ||
                                    !isAlphaNumeric(event.target.value)
                                )
                                    return;
                                props.formikState.setFieldValue('arn2', event.target.value);
                            }}
                            value={props.formikState.values.arn2}
                            name="arn2"
                            InputProps={{
                                startAdornment: <InputAdornment position="start"></InputAdornment>,
                            }}
                        />
                        <TextField
                            label={dbCommercial.exploreMfs.mfInvestment.subBrokerArnCode}
                            id="sub-broker-arn-code"
                            variant="outlined"
                            placeholder="Optional"
                            // error={isError(props.formikState, 'arn3')}
                            // helperText={showHelperText(props.formikState, 'arn3')}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if (
                                    event.target.value.length > MAX_LENGTHS.SUB_BROKER_ARN_LENGTH ||
                                    !event.target.value.match(/^[0-9]*$/)
                                )
                                    return;
                                props.formikState.setFieldValue('arn3', event.target.value);
                            }}
                            value={props.formikState.values.arn3}
                            name="arn3"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">ARN - </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div className="radio-div">
                        <p>{dbCommercial.exploreMfs.mfInvestment.euinNo}</p>
                        <CustomRadio
                            name="euin"
                            list={[
                                {
                                    label: dbCommercial.exploreMfs.mfInvestment.yes,
                                    value: IsAllow.YES,
                                },
                                {
                                    label: dbCommercial.exploreMfs.mfInvestment.no,
                                    value: IsAllow.No,
                                },
                            ]}
                            selectedValue={props.formikState.values.euin}
                            handleRadioChange={(value: IsAllow) => {
                                value === IsAllow.YES
                                    ? props.formikState.setFieldValue('euinDeclaration', false)
                                    : props.formikState.setFieldValue('euinCode', '');
                                props.formikState.setFieldValue('euin', value);
                            }}
                        />
                    </div>
                    <div
                        className="error-text"
                        style={{
                            color: 'red',
                            fontSize: 12,
                            position: 'relative',
                            top: -15,
                        }}
                    >
                        {isError(props.formikState, 'euin') ? props.formikState.errors.euin : null}
                    </div>
                    {props.formikState.values.euin === IsAllow.YES && (
                        <div style={{ maxWidth: 300, width: '100%', marginTop: -15 }}>
                            <TextField
                                variant="outlined"
                                name="euinCode"
                                value={props.formikState.values.euinCode}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    //allow only numbers
                                    const numberRegex = /^[0-9]*$/;
                                    if (
                                        event.target.value.length > MAX_LENGTHS.EUIN_LENGTH ||
                                        !numberRegex.test(event.target.value)
                                    )
                                        return;
                                    props.formikState.setFieldValue('euinCode', event.target.value);
                                }}
                                error={isError(props.formikState, 'euinCode')}
                                helperText={showHelperText(props.formikState, 'euinCode')}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">E</InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                    )}
                    {props.formikState.values.euin == IsAllow.No && (
                        <>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="euinDeclaration"
                                        checked={props.formikState.values.euinDeclaration}
                                        onChange={props.formikState.handleChange}
                                    />
                                }
                                label={
                                    <>
                                        {dbCommercial.exploreMfs.mfInvestment.iAgree}
                                        <a
                                            onClick={() => props.setEuin(true)}
                                            style={{ color: '#836fe0' }}
                                        >
                                            {dbCommercial.exploreMfs.mfInvestment.euinDeclaration}
                                        </a>
                                    </>
                                }
                            />
                            <div
                                className="error-text"
                                style={{
                                    color: 'red',
                                    fontSize: 12,
                                    position: 'relative',
                                    top: -15,
                                }}
                            >
                                {props.formikState.errors.euinDeclaration}
                            </div>
                        </>
                    )}
                </>
            ) : props.formikState.values.investThrough === InvestThrough.ria ? (
                <div style={{ maxWidth: 300, width: '100%' }}>
                    <TextField
                        label={dbCommercial.exploreMfs.mfInvestment.riaCode}
                        id="sub-broker-arn-code"
                        variant="outlined"
                        name="riaCode"
                        error={isError(props.formikState, 'riaCode')}
                        helperText={showHelperText(props.formikState, 'riaCode')}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            const numberRegex = /^[0-9]*$/;
                            if (
                                event.target.value.length > MAX_LENGTHS.RIA_LENGTH ||
                                !numberRegex.test(event.target.value)
                            )
                                return;
                            props.formikState.setFieldValue('riaCode', event.target.value);
                        }}
                        value={props.formikState.values.riaCode}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Select
                                        onChange={(e) =>
                                            props.formikState.setFieldValue(
                                                'riaFlag',
                                                e.target.value,
                                            )
                                        }
                                        value={props.formikState.values.riaFlag}
                                    >
                                        <MenuItem value={'INA'}>INA</MenuItem>
                                        <MenuItem value={UI_KEYS.INP}>INP</MenuItem>
                                    </Select>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
            ) : null}
        </div>
    );
};
